

// import { useProperty } from "../context/PropertyContext";
// import { MapPin, Expand, Route, Droplet, BadgeCheck, IndianRupee } from "lucide-react";
// import { useState, useEffect } from "react";

// export default function PropertyForm() {
//   const { properties, addProperty } = useProperty();
//   const [localProperty, setLocalProperty] = useState({
//     title: "",
//     location: "",
//     category: "",
//     tagline: "",
//     heroImage: null,
//     gallery: [],
//     soilType: "",
//     elevation: "",
//     crops: "",
//     yield: "",
//     rainfall: "",
//     features: [],
//     overview: "",
//     landSize: "",
//     roadAccess: "",
//     pricing: "",
//     waterSource: "",
//     legalStatus: "",
//     documents: {},
//     status: "Available",
//     enableVisit: false,
//   });
//   const [featureInput, setFeatureInput] = useState("");

//   const convertToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//     });
//   };

//   const updateField = (key, value) => {
//     setLocalProperty((prev) => ({ ...prev, [key]: value }));
//   };

//   const addFeature = () => {
//     if (!featureInput) return;
//     updateField("features", [...(localProperty.features || []), featureInput]);
//     setFeatureInput("");
//   };

//   const handleDocUpload = (file, field) => {
//     updateField("documents", { ...(localProperty.documents || {}), [field]: file.name });
//   };

//   const handleSave = () => {
//     // push new property into context
//     addProperty(localProperty);

//     // Save entire array to localStorage
//     const updatedProperties = [...properties, localProperty];
//     localStorage.setItem("propertyData", JSON.stringify(updatedProperties));

//     // Clear form for next entry
//     setLocalProperty({
//       title: "",
//       location: "",
//       category: "",
//       tagline: "",
//       heroImage: null,
//       gallery: [],
//       soilType: "",
//       elevation: "",
//       crops: "",
//       yield: "",
//       rainfall: "",
//       features: [],
//       overview: "",
//       landSize: "",
//       roadAccess: "",
//       pricing: "",
//       waterSource: "",
//       legalStatus: "",
//       documents: {},
//       status: "Available",
//       enableVisit: false,
//     });
//     setFeatureInput("");

//     // alert("Property saved! Ready for next entry.");
//   };

//   const property = localProperty;

//   return (
//     <div className="max-w-7xl mx-auto grid grid-cols-3 gap-6 mt-10">
//       {/* LEFT */}
//       <div className="col-span-2 space-y-6">
//         <Card title="Basic Information">
//           <Field label="Property Title" value={property.title || ""} onChange={(e) => updateField("title", e.target.value)} />
//           <Field label="Location" value={property.location || ""} onChange={(e) => updateField("location", e.target.value)} />
// <div>
//   <Label text="Category" />
//   <select
//     value={property.category || ""}
//     onChange={(e) => updateField("category", e.target.value)}
//     className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-2 outline-none focus:border-green-500"
//   >
//     <option value="">Select Category</option>
//     <option value="Agricultural Land">Agricultural Land</option>
//     <option value="Residential Plots">Residential Plots</option>
//     <option value="Investment Land">Investment Land</option>
//     <option value="Commercial Land">Commercial Land</option>
//   </select>
// </div>          <Field label="Short Tagline" value={property.tagline || ""} onChange={(e) => updateField("tagline", e.target.value)} />
//         </Card>

//         <Card title="Visual Assets">
//           <Label text="Hero Image" />
//           <div className="relative h-40">
//             <label className="flex items-center justify-center border-2 border-dashed border-[#E6E6E6] rounded-lg cursor-pointer h-full overflow-hidden">
//               {property.heroImage ? <img src={property.heroImage} className="w-full h-full object-cover" /> : <span className="text-sm text-gray-400">Upload</span>}
//               <input type="file" hidden onChange={async (e) => {
//                 const file = e.target.files[0];
//                 if (!file) return;
//                 const base64 = await convertToBase64(file);
//                 updateField("heroImage", base64);
//               }} />
//             </label>
//             {property.heroImage && <button onClick={() => updateField("heroImage", null)} className="absolute top-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">✕</button>}
//           </div>

//           <Label text="Gallery (Max 10)" />
//           <div className="border border-dashed border-[#E6E6E6] rounded-xl p-4">
//             <div className="flex flex-wrap gap-3">
//               {(property.gallery || []).map((img, i) => (
//                 <div key={i} className="relative w-24 h-24">
//                   <img src={img} className="w-full h-full object-cover rounded-lg" />
//                   <button onClick={() => updateField("gallery", property.gallery.filter((_, index) => index !== i))} className="absolute top-1 right-1 bg-black text-white text-xs px-1 rounded">✕</button>
//                 </div>
//               ))}
//             </div>
//             {(property.gallery || []).length < 10 && (
//               <label className="mt-3 inline-block cursor-pointer text-green-600 text-sm">
//                 + Add Image
//                 <input type="file" hidden onChange={async (e) => {
//                   const file = e.target.files[0];
//                   if (!file) return;
//                   const base64 = await convertToBase64(file);
//                   updateField("gallery", [...(property.gallery || []), base64]);
//                 }} />
//               </label>
//             )}
//           </div>
//         </Card>

//         <Card title="Overview">
//           <Label text="Land Overview" />
//           <textarea value={property.overview || ""} onChange={(e) => updateField("overview", e.target.value)} className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-3 h-32 outline-none focus:border-green-500" />
//         </Card>

//         <Card title="Land Specifications">
//           <div className="grid grid-cols-2 gap-4">
//             <Field label="Soil Type" value={property.soilType || ""} onChange={(e) => updateField("soilType", e.target.value)} />
//             <Field label="Elevation" value={property.elevation || ""} onChange={(e) => updateField("elevation", e.target.value)} />
//             <Field label="Crops" value={property.crops || ""} onChange={(e) => updateField("crops", e.target.value)} />
//             <Field label="Yield" value={property.yield || ""} onChange={(e) => updateField("yield", e.target.value)} />
//             <Field label="Rainfall" value={property.rainfall || ""} onChange={(e) => updateField("rainfall", e.target.value)} />
//           </div>

//           <div className="mt-4">
//             <p className="font-medium mb-2">Key Features</p>
//             {(property.features || []).map((f, i) => (
//               <div key={i} className="flex gap-2 items-center mb-2">
//                 <Input value={f} onChange={(e) => {
//                   const arr = [...property.features];
//                   arr[i] = e.target.value;
//                   updateField("features", arr);
//                 }} />
//                 <button onClick={() => updateField("features", property.features.filter((_, idx) => idx !== i))} className="text-red-500">✕</button>
//               </div>
//             ))}
//             <div className="flex gap-2">
//               <Input placeholder="Add feature" value={featureInput} onChange={(e) => setFeatureInput(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addFeature(); } }} />
//               <button onClick={addFeature} className="bg-green-600 text-white px-4 rounded-lg">Add</button>
//             </div>
//           </div>
//         </Card>
//       </div>

//       {/* RIGHT */}
//       <div className="space-y-6">
//         <Card title="Quick Highlights">
//           <IconInput icon={<MapPin size={16} />} label="Location" value={property.location || ""} onChange={(e) => updateField("location", e.target.value)} />
//           <IconInput icon={<Expand size={16} />} label="Land Size" value={property.landSize || ""} onChange={(e) => updateField("landSize", e.target.value)} />
//           <IconInput icon={<Route size={16} />} label="Road Access" value={property.roadAccess || ""} onChange={(e) => updateField("roadAccess", e.target.value)} />
//           <IconInput icon={<IndianRupee size={16} />} label="Pricing" value={property.pricing || ""} onChange={(e) => updateField("pricing", e.target.value)} />
//           <IconInput icon={<Droplet size={16} />} label="Water Source" value={property.waterSource || ""} onChange={(e) => updateField("waterSource", e.target.value)} />
//           <IconInput icon={<BadgeCheck size={16} />} label="Legal Status" value={property.legalStatus || ""} onChange={(e) => updateField("legalStatus", e.target.value)} />
//         </Card>

//         <Card title="Docs & Settings">
//           <DocUpload label="Title Deed" field="deed" property={property} handleDocUpload={handleDocUpload} />
//           <DocUpload label="Survey Document" field="survey" property={property} handleDocUpload={handleDocUpload} />
//           <DocUpload label="Approval Certificate" field="approval" property={property} handleDocUpload={handleDocUpload} />
//          {/* Property Status Dropdown */}
//   <div className="mt-4">
//     <Label text="Property Status" />
//     <select
//       value={property.status || "Available"}
//       onChange={(e) => updateField("status", e.target.value)}
//       className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-2 outline-none focus:border-green-500"
//     >
//       <option value="Available">Available</option>
//       <option value="Booked">Booked</option>
//       <option value="Sold">Sold</option>
//     </select>
//   </div>

//   {/* Enable Visit Toggle */}
//   <div className="flex items-center gap-3 mt-4">
//   <Label text="Enable Visit Request" />
//   <label className="relative inline-flex items-center cursor-pointer">
//     <input
//       type="checkbox"
//       className="sr-only peer"
//       checked={property.enableVisit || false}
//       onChange={(e) => updateField("enableVisit", e.target.checked)}
//     />
//     <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-green-500 rounded-full peer peer-checked:bg-green-600 transition-all"></div>
//     <div
//       className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transform transition-all peer-checked:translate-x-5`}
//     ></div>
//   </label>
// </div>

//         </Card>

//         <button onClick={handleSave} className="w-full bg-green-600 text-white py-3 rounded-lg">Save Property</button>
//       </div>
//     </div>
//   );
// }

// /* --- COMPONENTS --- */
// function Card({ title, children }) {
//   return <div className="bg-white p-6 rounded-xl shadow-sm transition"><h2 className="font-semibold mb-4">{title}</h2>{children}</div>;
// }
// function Label({ text }) { return <p className="text-sm mb-1">{text}</p>; }
// function Input(props) { return <input {...props} className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-2 mb-2 outline-none focus:border-green-500" />; }
// function Field({ label, ...props }) { return <div><Label text={label} /><Input {...props} /></div>; }
// function IconInput({ icon, label, value, onChange }) { return <div className="mb-4"><div className="flex items-center gap-2 mb-1"><div className="text-green-600">{icon}</div><p className="text-sm font-medium">{label}</p></div><input value={value} onChange={onChange} className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-2 outline-none focus:border-green-500" /></div>; }

// function DocUpload({ label, field, property, handleDocUpload }) {
//   return (
//     <div className="flex justify-between border border-dashed rounded-lg p-2 mb-2">
//       {(property.documents && property.documents[field]) || label}
//       <label className="text-green-600 text-sm cursor-pointer">
//         Upload
//         <input type="file" hidden onChange={(e) => handleDocUpload(e.target.files[0], field)} />
//       </label>
//     </div>
//   );
// }


import { MapPin, Expand, Route, Droplet, BadgeCheck, IndianRupee } from "lucide-react";
import { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import toast from "react-hot-toast";

export default function PropertyForm() {
  const [localProperty, setLocalProperty] = useState({
    title: "",
    location: "",
    category: "",
    tagline: "",
    heroImage: null,
    gallery: [],
    soilType: "",
    elevation: "",
    crops: "",
    yield: "",
    rainfall: "",
    features: [],
    overview: "",
    landSize: "",
    roadAccess: "",
    pricing: "",
    waterSource: "",
    legalStatus: "",
    documents: {},
    status: "Available",
    enableVisit: false,
  });
  const [featureInput, setFeatureInput] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get("id");
  const mode = searchParams.get("mode");
  const isViewMode = mode === "view";

  const updateField = (key, value) =>
    setLocalProperty((prev) => ({ ...prev, [key]: value }));

  const addFeature = () => {
    if (!featureInput) return;
    updateField("features", [...(localProperty.features || []), featureInput]);
    setFeatureInput("");
  };

  const handleDocUpload = (file, field) => {
    updateField("documents", { ...(localProperty.documents || {}), [field]: file.name });
  };

const handleSave = async () => {
  try {
    const formData = new FormData();

    // NORMAL FIELDS
    Object.keys(localProperty).forEach((key) => {
      if (key === "heroImage" || key === "gallery" || key === "documents") return;

      let value = localProperty[key];

      // arrays convert
      if (Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
      }
      // boolean convert
      else if (typeof value === "boolean") {
        formData.append(key, value ? "true" : "false");
      }
      else {
        formData.append(key, value ?? "");
      }
    });

    // HERO IMAGE
    if (localProperty.heroImage instanceof File) {
      formData.append("heroImage", localProperty.heroImage);
    } 
    else if (localProperty.heroImage === null) {
      formData.append("removeHeroImage", "true");
    } 
    else if (localProperty.heroImage?.url) {
      formData.append("existingHeroImage", localProperty.heroImage.url);
    }

    // GALLERY
    const existingGallery = [];

    (localProperty.gallery || []).forEach((img) => {
      if (img instanceof File) {
        formData.append("gallery", img);
      } else if (img?.url) {
        existingGallery.push(img.url);
      }
    });

    formData.append("existingGallery", JSON.stringify(existingGallery));

    // DOCUMENTS
    if (localProperty.documents) {
      formData.append("documents", JSON.stringify(localProperty.documents));
    }

    // API CALL
    const apiConfig =
      mode === "edit"
        ? {
            url: SummaryApi.updateOneProperty.url(propertyId),
            method: SummaryApi.updateOneProperty.method,
          }
        : {
            url: SummaryApi.createProperty.url,
            method: SummaryApi.createProperty.method,
          };

    await api({
      ...apiConfig,
      data: formData,
    });

    toast.success(mode === "edit" ? "Property updated" : "Property created");
    navigate("/admin-panel/property-list");

  } catch (error) {
    console.error("Save error:", error);
    toast.error("Save failed");
  }
};
  const property = localProperty;

  const fetchProperty = useCallback(async () => {
    try {
      const res = await api({
        url: SummaryApi.getOneProperty.url(propertyId),
        method: SummaryApi.getOneProperty.method,
      });

      const data = res.data?.data;

      if (data) {
        setLocalProperty({
          title: data.title || "",
          location: data.location || "",
          category: data.category || "",
          tagline: data.tagline || "",
          overview: data.overview || "",
          landSize: data.landSize || "",
          roadAccess: data.roadAccess || "",
          pricing: data.pricing || "",
          waterSource: data.waterSource || "",
          legalStatus: data.legalStatus || "",
          status: data.status || "Available",
          enableVisit: data.enableVisit || false,
          heroImage: data.heroImage || null,
          gallery: data.gallery || [],
          soilType: data.soilType,
          elevation: data.elevation,
          yield: data.yield,
          crops: data.crops,
          rainfall: data.rainfall,
          features: data.features || [],

        });
      }
    } catch (error) {
      console.error("Fetch property error:", error);
    }
  }, [ propertyId ]);

  useEffect(() => {
    if (propertyId) {
      fetchProperty();
    }
  }, [propertyId, fetchProperty]);

  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* LEFT */}
        <div className="lg:col-span-2 space-y-6">
          <Card title="Basic Information">
            <Field
              label="Property Title"
              value={property.title || ""}
              disabled={isViewMode}
              onChange={(e) => updateField("title", e.target.value)}
            />

            <Field
              label="Location"
              value={property.location || ""}
              disabled={isViewMode}
              onChange={(e) => updateField("location", e.target.value)}
            />
            {/* Category + Tagline wrapper */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <Label text="Category" />
                <select
                  value={property.category || ""}
                  disabled={isViewMode}
                  onChange={(e) => updateField("category", e.target.value)}
                  className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-2 outline-none focus:border-green-500"
                >
                  <option value="">Select Category</option>
                  <option value="Agricultural Land">Agricultural Land</option>
                  <option value="Residential Plots">Residential Plots</option>
                  <option value="Investment Land">Investment Land</option>
                  <option value="Commercial Land">Commercial Land</option>
                  <option value="Home">Home</option>
                </select>
              </div>

              <Field label="Short Tagline"
                value={property.tagline || ""}
                disabled={isViewMode}
                onChange={(e) => updateField("tagline", e.target.value)} />
            </div>
          </Card>

          <Card title="Visual Assets">
            <Label text="Hero Image" />
            <div className="relative h-40">
              <label className="flex items-center justify-center border-2 border-dashed border-[#E6E6E6] rounded-lg cursor-pointer h-full overflow-hidden">
                {property.heroImage?(
                  <img
                    src={
                      property.heroImage?.url
                        ? property.heroImage.url
                        : property.heroImage
                          ? URL.createObjectURL(property.heroImage)
                          : ""
                    }
                    alt="Hero"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span className="text-sm text-gray-400">Upload</span>
                )}
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    updateField("heroImage", file);
                  }}
                />
              </label>
              {property.heroImage && (
                <button onClick={() => updateField("heroImage", null)} className="absolute top-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">✕</button>
              )}
            </div>

            {/* <Label text="Gallery (Max 10)" />
            <div className="border border-dashed border-[#E6E6E6] rounded-xl p-4">
              <div className="flex flex-wrap gap-3">
                {(property.gallery || []).map((img, i) => (
                  <div key={i} className="relative w-24 h-24">
                    <img
                      src={img?.url ? img.url : URL.createObjectURL(img)}
                      alt="img"
                      className="w-full h-full object-cover rounded-lg"
                    />                    <button onClick={() => updateField("gallery", property.gallery.filter((_, index) => index !== i))} className="absolute top-1 right-1 bg-black text-white text-xs px-1 rounded">✕</button>
                  </div>
                ))}
              </div>
              {(property.gallery || []).map((img, i) => (
                <div key={i} className="relative w-24 h-24">
                  <img
                    src={img?.url ? img.url : URL.createObjectURL(img)}
                    alt="img"
                    className="w-full h-full object-cover rounded-lg"
                  />
                  <button
                    onClick={() =>
                      updateField(
                        "gallery",
                        property.gallery.filter((_, index) => index !== i)
                      )
                    }
                    className="absolute top-1 right-1 bg-black text-white text-xs px-1 rounded"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div> */}
            {/* <Label text="Gallery (Max 10)" />
<div className="border border-dashed border-[#E6E6E6] rounded-xl p-4">
  <div className="flex flex-wrap gap-3">
    {(property.gallery || []).map((img, i) => (
      <div key={i} className="relative w-24 h-24">
        <img
          src={img?.url ? img.url : URL.createObjectURL(img)}
          alt="img"
          className="w-full h-full object-cover rounded-lg"
        />
        <button
          onClick={() =>
            updateField(
              "gallery",
              property.gallery.filter((_, index) => index !== i)
            )
          }
          className="absolute top-1 right-1 bg-black text-white text-xs px-1 rounded"
        >
          ✕
        </button>
      </div>
    ))}
  </div>
</div>
<input
  type="file"
  multiple
  accept="image/*"
  onChange={(e) => {
    const files = Array.from(e.target.files);

    if (property.gallery.length + files.length > 10) {
      toast.error("Maximum 10 images allowed");
      return;
    }

    updateField("gallery", [...property.gallery, ...files]);
  }}
/> */}

<Label text="Gallery (Max 10)" />
<div className="border border-dashed border-[#E6E6E6] rounded-xl p-4">
  <div className="flex flex-wrap gap-3">

    {/* Existing Images */}
    {(property.gallery || []).map((img, i) => (
      <div key={i} className="relative w-24 h-24">
        <img
          src={img?.url ? img.url : URL.createObjectURL(img)}
          alt="img"
          className="w-full h-full object-cover rounded-lg"
        />
        <button
          onClick={() =>
            updateField(
              "gallery",
              property.gallery.filter((_, index) => index !== i)
            )
          }
          className="absolute top-1 right-1 bg-black text-white text-xs px-1 rounded"
        >
          ✕
        </button>
      </div>
    ))}

    {/* Upload Box */}
    {(property.gallery || []).length < 10 && (
      <label className="w-24 h-24 flex items-center justify-center border-2 border-dashed border-[#E6E6E6] rounded-lg cursor-pointer text-sm text-gray-400 hover:border-green-500">
        Upload
        <input
          type="file"
          hidden
          multiple
          accept="image/*"
          onChange={(e) => {
            const files = Array.from(e.target.files);

            if ((property.gallery || []).length + files.length > 10) {
              toast.error("Maximum 10 images allowed");
              return;
            }

            updateField("gallery", [
              ...(property.gallery || []),
              ...files,
            ]);

            e.target.value = null;
          }}
        />
      </label>
    )}

  </div>
</div>
          </Card>

          <Card title="Overview">
            <Label text="Land Overview" />
            <textarea value={property.overview || ""} onChange={(e) => updateField("overview", e.target.value)} className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-3 h-32 outline-none focus:border-green-500" />
          </Card>

          <Card title="Land Specifications">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Field label="Soil Type" value={property.soilType || ""} onChange={(e) => updateField("soilType", e.target.value)} />
              <Field label="Elevation" value={property.elevation || ""} onChange={(e) => updateField("elevation", e.target.value)} />
              <Field label="Crops" value={property.crops || ""} onChange={(e) => updateField("crops", e.target.value)} />
              <Field label="Yield" value={property.yield || ""} onChange={(e) => updateField("yield", e.target.value)} />
              <Field label="Rainfall" value={property.rainfall || ""} onChange={(e) => updateField("rainfall", e.target.value)} />
            </div>

            <div className="mt-4">
              <p className="font-medium mb-2">Key Features</p>
              {(property.features || []).map((f, i) => (
                <div key={i} className="flex gap-2 items-center mb-2">
                  <Input value={f} onChange={(e) => {
                    const arr = [...property.features];
                    arr[i] = e.target.value;
                    updateField("features", arr);
                  }} />
                  <button onClick={() => updateField("features", property.features.filter((_, idx) => idx !== i))} className="text-red-500">✕</button>
                </div>
              ))}
              <div className="flex flex-col sm:flex-row gap-2">
                <Input
                  placeholder="Add feature"
                  value={featureInput}
                  onChange={(e) => setFeatureInput(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addFeature(); } }}
                  className="h-10" // force input height
                />
                <button
                  onClick={addFeature}
                  className="bg-[#45A301] text-white rounded-lg font-medium transition-all
                h-10 px-4 text-sm sm:text-base w-full sm:w-auto hover:bg-green-700"
                >
                  Add
                </button>
              </div>
            </div>
          </Card>
        </div>

        {/* RIGHT */}
        <div className="space-y-6">
          <Card title="Quick Highlights">
            <IconInput icon={<MapPin size={16} />} label="Location" value={property.location || ""} onChange={(e) => updateField("location", e.target.value)} />
            <IconInput icon={<Expand size={16} />} label="Land Size" value={property.landSize || ""} onChange={(e) => updateField("landSize", e.target.value)} />
            <IconInput icon={<Route size={16} />} label="Road Access" value={property.roadAccess || ""} onChange={(e) => updateField("roadAccess", e.target.value)} />
            <IconInput icon={<IndianRupee size={16} />} label="Pricing" value={property.pricing || ""} onChange={(e) => updateField("pricing", e.target.value)} />
            <IconInput icon={<Droplet size={16} />} label="Water Source" value={property.waterSource || ""} onChange={(e) => updateField("waterSource", e.target.value)} />
            <IconInput icon={<BadgeCheck size={16} />} label="Legal Status" value={property.legalStatus || ""} onChange={(e) => updateField("legalStatus", e.target.value)} />
          </Card>

          <Card title="Docs & Settings">
            <DocUpload label="Title Deed" field="deed" property={property} handleDocUpload={handleDocUpload} />
            <DocUpload label="Survey Document" field="survey" property={property} handleDocUpload={handleDocUpload} />
            <DocUpload label="Approval Certificate" field="approval" property={property} handleDocUpload={handleDocUpload} />

            {/* Property Status Dropdown */}
            <div className="mt-4">
              <Label text="Property Status" />
              <select
                value={property.status || "Available"}

                onChange={(e) => updateField("status", e.target.value)}
                className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-2 outline-none focus:border-green-500"
              >
                <option value="Available">Available</option>
                <option value="Booked">Booked</option>
                <option value="Sold">Sold</option>
              </select>
            </div>

            {/* Enable Visit Request Toggle */}
            <div className="flex items-center gap-3 mt-6"> {/* ↑ increased mt from 4 → 6 */}
              <Label text="Enable Visit Request" />
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={property.enableVisit || false}
                  onChange={(e) => updateField("enableVisit", e.target.checked)}
                />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-green-500 rounded-full peer peer-checked:bg-green-600 transition-all"></div>
                <div
                  className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full  transform transition-all peer-checked:translate-x-5`}
                ></div>
              </label>
            </div>
          </Card>

          <button onClick={handleSave} className="w-full bg-[#45A301] text-white py-3 rounded-lg">Save Property</button>
        </div>
      </div>
    </div>
  );
}

/* --- COMPONENTS --- */
function Card({ title, children }) {
  return <div className="bg-white p-6 rounded-xl  transition">{title && <h2 className="font-semibold mb-4">{title}</h2>}{children}</div>;
}
function Label({ text }) { return <p className="text-sm mb-1">{text}</p>; }
function Input({ disabled, ...props }) {
  return (
    <input
      {...props}
      disabled={disabled}
      className={`w-full border rounded-lg p-2 mb-2 outline-none 
        ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-[#F9F9F9] focus:border-green-500 border-[#E6E6E6]"}`}
    />
  );
} function Field({ label, disabled, ...props }) {
  return (
    <div>
      <Label text={label} />
      <Input {...props} disabled={disabled} />
    </div>
  );
}
function IconInput({ icon, label, value, onChange }) { return <div className="mb-4"><div className="flex items-center gap-2 mb-1"><div className="text-green-600">{icon}</div><p className="text-sm font-medium">{label}</p></div><input value={value} onChange={onChange} className="w-full bg-[#F9F9F9] border border-[#E6E6E6] rounded-lg p-2 outline-none focus:border-green-500" /></div>; }
function DocUpload({ label, field, property, handleDocUpload }) {
  return (
    <div className="flex justify-between border border-dashed rounded-lg p-2 mb-2">
      {/* Text with smaller font and gray color */}
      <span className="text-gray-500 text-sm">
        {(property.documents && property.documents[field]) || label}
      </span>

      {/* Upload button */}
      <label className="text-green-600 text-sm cursor-pointer">
        Upload
        <input type="file" hidden onChange={(e) => handleDocUpload(e.target.files[0], field)} />
      </label>
    </div>
  );
}